var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 11.625H7.375M7.375 11.625V8.4375M7.375 11.625H12.6875M12.6875 11.625V8.4375M12.6875 11.625H18M18 11.625V8.4375M18 11.625H23.3125M9.5 15.875H11.625M13.75 15.875H15.875M13.75 19.0625H15.875M9.5 19.0625H11.625M3.125 24.375V11.625H1V7.375L4.1875 1H21.1875L24.375 7.375V11.625H22.25V24.375H3.125Z",
    stroke: "#5D44FF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.f5219e3c37b67959dc2036c62c1496c7.svg";
export { ForwardRef as ReactComponent };